<form (ngSubmit)="onSubmit()"
        class="d-flex flex-column justify-content-center align-items-center w-100 p-4">
      <div >
        <h5>Wysłanie żądania usunięcia notatki</h5>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
      </div>
      <mat-dialog-content>
        <!-- <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-layout"> -->
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>Powód usunięcia</mat-label>
            <textarea  matInput type="text" placeholder="Podaj powód usunięcia notatki" required [formControl]="deleteReson"></textarea>
            <mat-error *ngIf="deleteReson.hasError('required')">
                Podaj powód usunięcia notatki
            </mat-error>
          </mat-form-field>
        
      <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2" >
          <button mat-flat-button color="warn" class="btn btn-secondary" mat-dialog-close >Zamknij</button>
          <button mat-flat-button class="btn-with-icon s-button" color="accent" type="submit">Wyślij żądanie</button>
      </mat-dialog-actions>
    </mat-dialog-content>
    </form>